import { RedocStandalone } from 'redoc';

export default function Swagger() {
    return (
        <div>
            <RedocStandalone specUrl={process.env.REACT_APP_SWAGGER} />
        </div>
    )
}